<div class="fantasy-container">
  <!--Mobile Navigation-->
  <fgb-mobile-nav-menu [pageName]="'games.page.pickaplayer.title' | translate"></fgb-mobile-nav-menu>
  <ng-container *ifScreenSize="screenType.Desktop">
    <div class="container banner-container d-flex flex-column pt-3">
      <a
        class="d-none d-lg-flex text-white page-back-button-section bg-primary align-items-center"
        routerLink="/games"
        aria-label="Back"
      >
        <span class="material-icons me-2">arrow_back_ios_new</span>
      </a>

      @if (kidType$ | async; as kidType) {
        @if (isClub1901) {
          <img class="banner-img" [src]="'1901/games/pap-banner.png' | contentAssetImage" />
        } @else if (isKid && kidType === 'All-Stars') {
          <img class="banner-img" [src]="'kids/banners/allstars/pap.png' | contentAssetImage" />
        } @else if (isKid) {
          <img class="banner-img" [src]="'kids/banners/baller/pap.png' | contentAssetImage" />
        } @else {
          <img class="banner-img" [src]="'games/pap-banner.png' | contentAssetImage" />
        }
      }
    </div>
  </ng-container>

  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="mobile-banner-container container">
      @if (kidType$ | async; as kidType) {
        @if (isClub1901) {
          <img class="banner-img" [src]="'1901/games/pap-banner.png' | contentAssetImage" />
        } @else if (isKid && kidType === 'All-Stars') {
          <img class="banner-img" [src]="'kids/banners/allstars/pap.png' | contentAssetImage" />
        } @else if (isKid) {
          <img class="banner-img" [src]="'kids/banners/baller/pap.png' | contentAssetImage" />
        } @else {
          <img class="banner-img" [src]="'games/pap-banner.png' | contentAssetImage" />
        }
      }
    </div>
    <div class="container points-leaderboard-container d-flex flex-row w-100">
      <div class="leaderboard-container justify-content-between d-flex flex-row bg-primary align-items-center">
        <div class="rank-icon">
          <span class="material-symbols-outlined"> crown </span>
        </div>
        <div class="rank-details d-flex flex-column align-items-end">
          <p class="font-size-10 text-uppercase text-white fw-bold mb-0">{{ 'fantasy.season.rank.mobile' | translate }}</p>

          <p class="font-size-24 text-white fw-bold mb-0">{{ currentUser?.Position || '-' }}</p>
        </div>
      </div>

      <div class="points-container d-flex flex-row justify-content-between bg-primary align-items-center">
        <div class="rank-icon">
          <span class="material-symbols-outlined"> trending_up </span>
        </div>
        <div class="points-details d-flex flex-column align-items-end">
          <p class="font-size-10 text-uppercase text-white fw-bold mb-0">{{ 'fantasy.total.points' | translate }}</p>

          <p class="font-size-24 text-white fw-bold mb-0">{{ currentUser?.Points || 0 }}</p>
        </div>
      </div>
    </div>
  </ng-container>

  <fgb-fantasy-nav></fgb-fantasy-nav>
  <router-outlet></router-outlet>
</div>
